__turbopack_context__.v({
  "buttonText": "D9tUma_buttonText",
  "buttons": "D9tUma_buttons",
  "container": "D9tUma_container",
  "content": "D9tUma_content",
  "description": "D9tUma_description",
  "emailText": "D9tUma_emailText",
  "header": "D9tUma_header",
  "iconTitle": "D9tUma_iconTitle",
  "iconTitleRegistration": "D9tUma_iconTitleRegistration",
  "iconTitleWrap": "D9tUma_iconTitleWrap",
  "iconTitleWrapRegistration": "D9tUma_iconTitleWrapRegistration",
  "title": "D9tUma_title",
});
